export const yesNoToggleSx = {
  container: {
    display: "flex",
    borderRadius: "4px",
    overflow: "hidden",
    width: "100px",
  },
  yesBox: {
    cursor: "pointer",
    fontWeight: "bold",
  },
  noBox: {
    cursor: "pointer",
    fontWeight: "bold",
  },
};
